module.exports = __webpack_public_path__ + "static/LogoWhite-b004956f9e739bf18224b3cec32de484.svg";